import React from "react";

export const CoursePreheaderInfo = () => {
  return(
    <div className="preheader-info-container">
      {window.I18n.t('courses.check_courses_notice')}
    </div>
  )
}